
import { Component, OnInit } from '@angular/core';
import { ITdDynamicElementConfig, TdDynamicElement, TdDynamicType } from '@covalent/dynamic-forms';
import { TdFileService, IUploadOptions } from '@covalent/core';
import { TdLoadingService } from '@covalent/core';
import { TdDialogService } from '@covalent/core';
import { Location } from '@angular/common';

import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/do';
import { Observable } from 'rxjs/Observable';

import { Catalog } from '../catalog';
import { CatalogService } from '../catalog.service';
import { AuthenticationService } from '../../../../shared/services/authentication.service';
import { MdDialogRef, MdDialog } from '@angular/material';

@Component({
  selector: 'app-catalog',
  templateUrl: './catalog.component.html',
  styleUrls: ['./catalog.component.scss']
})
export class CatalogComponent implements OnInit {
  data: Catalog;
  currentCatalog: Catalog;

  originalCatalog: Catalog;

  subscription: Subscription = new Subscription();
  title: string;
  isEditMode: boolean;

  constructor(private _dialogService: TdDialogService,
    private _loadingService: TdLoadingService,
    private _catalogService: CatalogService,
    public _authService: AuthenticationService,
    private _dialog: MdDialog,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location) { }

  ngOnInit(): void {
    this._loadingService.register('loading');

    this.route.paramMap.switchMap((params: ParamMap) => this.mode(params.get('id'))).subscribe(
      (currentCatalog: Catalog) => {
        this.currentCatalog = currentCatalog;
        
        // Load up the reference data
        this.originalCatalog = Object.assign({}, this.currentCatalog);

        this._loadingService.resolve('loading');
      });

  }


  goBack(): void {
    this.location.back();
  }

  changed(): boolean {
    for (let prop in this.currentCatalog) {
      if (this.currentCatalog[prop] != this.originalCatalog[prop]) {
        return true;
      }
    }

    return false;
  }



  mode(id: string): Observable<Catalog> {
    if (id) {
      this.title = 'Edit Catalog';
      this.isEditMode = true;
      return this._catalogService.getOneCatalog(id);
    }

    this.title = 'Create Catalog';
    this.isEditMode = false;
    return Observable.of(new Catalog());
  }


}




// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/purchasing/catalogs/catalog/catalog.component.ts